// extracted by mini-css-extract-plugin
var _1 = "LinkElement_description__a15e3";
var _2 = "LinkElement_emptyTitle__8b548";
var _3 = "LinkElement_icon__3f739";
var _4 = "LinkElement_linkIcon__4ec73";
var _5 = "LinkElement_mobile__48e31";
var _6 = "LinkElement_placeholder__d608f";
var _7 = "LinkElement_preview__d9bbb";
var _8 = "LinkElement_previewImg__13904";
var _9 = "LinkElement_previewInfo__61958";
export { _1 as "description", _2 as "emptyTitle", _3 as "icon", _4 as "linkIcon", _5 as "mobile", _6 as "placeholder", _7 as "preview", _8 as "previewImg", _9 as "previewInfo" }
